<div class="mu-dashboard">
  <div class="container" *ngIf="muList && muList?.length !== 0">
    <app-mu-block-item *ngFor="let mu of muList" [muList]="mu"></app-mu-block-item>
  </div>
  <app-table-no-data *ngIf="!muList || muList?.length === 0" [loadingFirst]="loading"></app-table-no-data>
</div>
